import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/plugins/i18n";
import vuetify from "@/plugins/vuetify";
import "./registerServiceWorker";

import "@/plugins";
import "@/utils";
import "@/validators";
import "@/components";
import "@/scss/main.scss";
import ReepayPlugin from "@/plugins/reepayPlugin";

Vue.config.productionTip = false;
Vue.use(ReepayPlugin);

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
